export const GHG_ADMINISTRATION_METHODOLOGY_ID = "scuz9cihxz8tcwxu96hat04n";
